<template>
  <div id="app" class="container-fluid">
    <mz-alert></mz-alert>
    <mz-debug></mz-debug>
    <mz-header></mz-header>
    <router-view></router-view>        
    <mz-footer></mz-footer>
  </div>
</template>

<script>
import Alert from '@/components/general/Alert'
import Debug from '@/components/debug/Debug'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'

export default {
  name: 'app',
  data () {
    return {
    }
  },
  components: {
    mzDebug: Debug,
    mzHeader: Header,
    mzFooter: Footer,
    mzAlert: Alert
  }
}
</script>

<style lang="scss">
@import "./scss/theme.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue